import api from "./api";

// Get current agent mode for a ticket
export const getAgentMode = async (ticketId) => {
  try {
    const { data } = await api.get(`/agent/tickets/${ticketId}/mode`);
    return data;
  } catch (error) {
    console.warn("Error getting agent mode:", error);
    // Return default state instead of throwing error to prevent white screen
    return {
      mode: null,
      isActive: false,
      canTakeover: false
    };
  }
};

// Request human takeover from AI agent
export const requestTakeover = async (ticketId) => {
  try {
    const { data } = await api.post(`/agent/tickets/${ticketId}/takeover`);
    return data;
  } catch (error) {
    console.warn("Error requesting takeover:", error);
    // Return default response to prevent white screen
    return { success: false, message: "Takeover not available" };
  }
};

// Accept an AI suggestion and send it as message
export const acceptAgentSuggestion = async (ticketId, suggestion) => {
  try {
    const { data } = await api.post(`/agent/tickets/${ticketId}/suggestions/accept`, {
      suggestionId: suggestion.id,
      message: suggestion.message || suggestion.content || suggestion.text
    });
    return data;
  } catch (error) {
    console.warn("Error accepting suggestion:", error);
    // Return default response to prevent white screen
    return { success: false, message: "Suggestion not accepted" };
  }
};

// Reject an AI suggestion
export const rejectAgentSuggestion = async (ticketId, suggestionId) => {
  try {
    const { data } = await api.post(`/agent/tickets/${ticketId}/suggestions/reject`, {
      suggestionId
    });
    return data;
  } catch (error) {
    console.warn("Error rejecting suggestion:", error);
    // Return default response to prevent white screen
    return { success: false, message: "Suggestion not rejected" };
  }
};

// Send agent suggestion as message (used by AgentSuggestionsPanel)
export const sendAgentSuggestion = async (ticketId, suggestion) => {
  try {
    const { data } = await api.post(`/agent/tickets/${ticketId}/suggestions/send`, {
      suggestionId: suggestion.id,
      message: suggestion.message || suggestion.content || suggestion.text
    });
    return data;
  } catch (error) {
    console.warn("Error sending suggestion:", error);
    // Return default response to prevent white screen
    return { success: false, message: "Suggestion not sent" };
  }
};

// Request AI suggestions for a ticket
export const requestAgentSuggestions = async (ticketId, context = {}) => {
  try {
    const { data } = await api.post(`/agent/tickets/${ticketId}/generate-suggestions`, {
      context: context.message || context.currentMessage || "",
      requestType: context.type || "manual_request",
      conversationContext: context.conversation || ""
    });
    return data;
  } catch (error) {
    console.error("Error requesting agent suggestions:", error);
    
    // Fallback to test suggestions if backend is not ready
    console.log("⚠️ Endpoint may not exist yet. Using fallback suggestions...");
    return {
      success: true,
      suggestions: [
        {
          id: 1,
          message: "Olá! Como posso ajudá-lo hoje?",
          confidence: 0.9,
          type: "Saudação",
          context: "Início de conversa"
        },
        {
          id: 2,
          message: "Entendo sua situação. Vou verificar isso para você imediatamente.",
          confidence: 0.8,
          type: "Resposta",
          context: "Cliente relatou problema"
        },
        {
          id: 3,
          message: "Posso agendar uma ligação para discutirmos melhor essa questão?",
          confidence: 0.7,
          type: "Proposta",
          context: "Situação complexa"
        }
      ]
    };
  }
};